<div class="flex flex-col gap-0 {{otherClasses}}">
  <span class="text-bold text-primary-500" *ngIf="key">{{ key }}</span>
  @if (customView) {
    <span class="p-2 {{ hasBorder ? 'text-bold text-muted my-2 lbb-dotted pb-1' : ''}}">
      <ng-container
        [ngTemplateOutlet]="customView">
      </ng-container>
    </span>
  } @else {
    <span
      class="text-bold text-muted mb-2 lbb-dotted pb-1">
      <span
        *ngIf="valueType != 'date' && valueType != 'translate' && valueType != 'number' && valueType != 'html'">{{ value | valueChecker }}</span>
      <span *ngIf="valueType == 'number'">{{ value | number }}</span>
      <span *ngIf="valueType == 'date'">{{ value | date }}</span>
      <span *ngIf="valueType == 'html'" [innerHtml]="value"></span>
      <span *ngIf="valueType == 'translate'" class="flex flex-col">
        <span>{{ value | language : 'sw' }}</span>
        <span class="text-[11px]">{{ value | language : 'en' }}</span>
      </span>
    </span>
  }
</div>
